"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SharedInterleavedConnector = void 0;
const rc_js_util_1 = require("rc-js-util");
const a_interleaved_connector_1 = require("./a-interleaved-connector");
/**
 * @public
 * {@inheritDoc ISharedInterleavedConnector}
 */
class SharedInterleavedConnector extends a_interleaved_connector_1.AInterleavedConnector {
    constructor(prefix, wrapper, sharedArray, config) {
        super(config, sharedArray.length, sharedArray.elementByteSize);
        this.cSetStart = `_${prefix}_setStart`;
        this.cSetLength = `_${prefix}_setLength`;
        this.wrapper = wrapper;
        this.sharedArray = sharedArray;
        const pointer = this.initialize(prefix, wrapper, sharedArray.sharedObject.getPtr());
        this.sharedObject = new rc_js_util_1.ReferenceCountedPtr(false, pointer);
        this.sharedObject.registerOnFreeListener(() => this.wrapper.instance._f32InterleavedConnector_delete(this.sharedObject.getPtr()));
        this.sharedObject.bindLifecycle(this.sharedArray.sharedObject);
    }
    static createOneExistingF32SharedArray(wrapper, sharedArray, config, owning) {
        const connector = new SharedInterleavedConnector("f32InterleavedConnector", wrapper, sharedArray, config);
        if (owning) {
            sharedArray.sharedObject.release();
        }
        return connector;
    }
    static createOneF32(wrapper, size, config) {
        const sharedArray = rc_js_util_1.SharedArray.createOneF32(wrapper, size, true);
        SharedInterleavedConnector.createOneExistingF32SharedArray(wrapper, sharedArray, config, true);
        return new SharedInterleavedConnector("f32InterleavedConnector", wrapper, sharedArray, config);
    }
    static createOneExistingF64SharedArray(wrapper, sharedArray, config, owning) {
        const connector = new SharedInterleavedConnector("f64InterleavedConnector", wrapper, sharedArray, config);
        if (owning) {
            sharedArray.sharedObject.release();
        }
        return connector;
    }
    static createOneF64(wrapper, size, config) {
        const sharedArray = rc_js_util_1.SharedArray.createOneF64(wrapper, size, true);
        SharedInterleavedConnector.createOneExistingF64SharedArray(wrapper, sharedArray, config, true);
        return new SharedInterleavedConnector("f64InterleavedConnector", wrapper, sharedArray, config);
    }
    getInterleavedBuffer() {
        return this.sharedArray.getInstance();
    }
    getData() {
        return this.sharedArray.getInstance();
    }
    setStart(index) {
        DEBUG_MODE && rc_js_util_1._Debug.assert(!this.sharedObject.getIsDestroyed(), "attempted modification of destroyed object");
        super.setStart(index);
        this.wrapper.instance[this.cSetStart](this.sharedObject.getPtr(), index);
    }
    setLength(length) {
        DEBUG_MODE && rc_js_util_1._Debug.assert(!this.sharedObject.getIsDestroyed(), "attempted modification of destroyed object");
        super.setLength(length);
        this.wrapper.instance[this.cSetLength](this.sharedObject.getPtr(), length);
    }
    initialize(prefix, wrapper, sharedArrayPtr) {
        const ctorArg = new SharedInterleavedConnectorArg(wrapper, this, sharedArrayPtr);
        const ptr = wrapper.instance[`_${prefix}_createOne`](ctorArg.sharedObject.getPtr());
        ctorArg.sharedObject.release();
        DEBUG_MODE && rc_js_util_1._Debug.assert(ctorArg.sharedObject.getIsDestroyed(), "expected arg to be destroyed after initialization");
        return ptr;
    }
}
exports.SharedInterleavedConnector = SharedInterleavedConnector;
class SharedInterleavedConnectorArg {
    constructor(wrapper, connector, sharedArrayPtr) {
        this.rvp = rc_js_util_1.RawVoidPointer.createOne(wrapper, Uint32Array.BYTES_PER_ELEMENT * 5, true);
        this.sharedObject = this.rvp.sharedObject;
        const dataView = this.rvp.getDataView();
        dataView.setUint32(0, sharedArrayPtr, SharedInterleavedConnectorArg.littleEndian);
        dataView.setUint32(Uint32Array.BYTES_PER_ELEMENT, connector.getStart(), SharedInterleavedConnectorArg.littleEndian);
        dataView.setUint32(Uint32Array.BYTES_PER_ELEMENT * 2, connector.getLength(), SharedInterleavedConnectorArg.littleEndian);
        dataView.setUint32(Uint32Array.BYTES_PER_ELEMENT * 3, connector.getMaximumLength(), SharedInterleavedConnectorArg.littleEndian);
        dataView.setUint32(Uint32Array.BYTES_PER_ELEMENT * 4, connector.getBlockElementCount(), SharedInterleavedConnectorArg.littleEndian);
    }
}
SharedInterleavedConnectorArg.littleEndian = rc_js_util_1.isLittleEndian;
//# sourceMappingURL=shared-interleaved-connector.js.map